module.exports = __webpack_public_path__ + "Posters0010-a11f0760994d19938fb7e7f89731195f.png";